import { useEffect } from "react";

// Utils
import PageContent from "../ListingPageContent";
import { getOnboardingPageName } from "../../utils/CommonFunctions";
import ModalOnboardingNavBars from "./ModalOnboardingNavBars";

interface IDynamicOnboardingPage {
  json: any;
  type: "page" | "modal";
  buttonStyle?: string;
}

const DynamicOnboardingPage = ({ json, type, buttonStyle }: IDynamicOnboardingPage) => {
  const PageBody = <PageContent json={json} theme={window.config.theme} pageName="onboarding" />;

  if (type === "modal") {
    return <ModalOnboardingNavBars buttonStyle={buttonStyle}>{PageBody}</ModalOnboardingNavBars>;
  }
  return PageBody;
};

export default DynamicOnboardingPage;
